import { StateSearch } from '../state_search';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';

export const update_search_locally = (state: StateSearch, search: DTOSearchSettings): void => {
  state.search_history_map.set(search._id, search);

  //need refresh map to trigger re-render
  state.search_history_map = new Map(state.search_history_map);

  if (state.search_current._id == search._id) {
    state.search_current = search;
  }
};
